/*
 * PCP back-in-stock (Klaviyo) - Oct 2026. Markup: snippets/pcp-back-in-stock.liquid.
 *
 * 1. On variant change (PUB_SUB_EVENTS.variantChange from product-info.js), when the selected
 *    variant is sold out, hide the standard buy buttons and show the "Notify me" block; reverse
 *    when an available size is picked. Enquire-mode products are left alone.
 * 2. The <pcp-back-in-stock> dialog posts the shopper's email for the selected variant to
 *    Klaviyo's client Back in Stock endpoint, and - only if the news box is ticked - subscribes
 *    them to the news list. Success/failure is shown in the dialog.
 */
(function () {
  if (window.__pcpBackInStock) return;
  window.__pcpBackInStock = true;

  var KLAVIYO_REVISION = '2025-01-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function qs(root, sel) { return root ? root.querySelector(sel) : null; }

  function setText(root, sel, value) {
    if (!root) return;
    root.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
  }

  /* ---------- 1. Swap buy buttons <-> notify block on variant change ---------- */

  function syncSection(sectionId, variant) {
    var block = document.getElementById('PcpBis-' + sectionId);
    if (!block || !variant) return;

    var buttons = document.getElementById('ProductFormButtons-' + sectionId);
    var enquireWrap = document.getElementById('EnquireWrap-' + sectionId);
    var isEnquire = enquireWrap && !enquireWrap.classList.contains('hidden');
    var soldOut = variant.available === false && !isEnquire;

    block.classList.toggle('hidden', !soldOut);
    if (buttons && !isEnquire) buttons.classList.toggle('hidden', soldOut);

    var size = variant.title && variant.title !== 'Default Title' ? variant.title : '';
    setText(block, '[data-bis-size]', size);

    var dialog = document.getElementById('PcpBisDialog-' + sectionId);
    if (dialog) dialog.setVariant(variant);
  }

  function initVariantSync() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.sectionId) return;
      syncSection(data.sectionId, data.variant);
    });
  }

  /* ---------- 2. The dialog ---------- */

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.shopSettings) {
        // The shop money format wraps the amount in <span class=money>; keep the text only.
        var tmp = document.createElement('div');
        tmp.innerHTML = theme.Currency.formatMoney(cents, theme.shopSettings.moneyFormat);
        return tmp.textContent.trim();
      }
    } catch (e) {}
    return null;
  }

  class PcpBackInStock extends HTMLElement {
    connectedCallback() {
      this.panel = qs(this, '.pcp-bis-dialog__panel');
      this.form = qs(this, '[data-bis-form]');
      this.emailInput = qs(this, 'input[name="email"]');
      this.newsInput = qs(this, 'input[name="news"]');
      this.errorEl = qs(this, '[data-bis-error]');
      this.submitBtn = qs(this, '[data-bis-submit]');
      this.lastFocus = null;
      if (this.__bound) return;

      // Move to <body> so the overlay isn't clipped by sticky/transformed product-info parents.
      this.__bound = true;
      if (this.parentElement !== document.body) document.body.appendChild(this);

      this.querySelectorAll('[data-bis-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
        if (e.key === 'Tab') this.trapFocus(e);
      });
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.submit();
      });
    }

    setVariant(variant) {
      if (!variant) return;
      this.dataset.variantId = variant.id;
      var size = variant.title && variant.title !== 'Default Title' ? variant.title : '';
      setText(this, '[data-bis-size]', size);
      var price = formatMoney(variant.price);
      if (price) setText(this, '[data-bis-price]', price);
      var img = qs(this, '[data-bis-image]');
      if (img && variant.featured_image && variant.featured_image.src) {
        img.src = variant.featured_image.src + (variant.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      }
    }

    currentVariantId() {
      var input = document.querySelector('#product-form-' + this.dataset.section + ' input[name="id"]');
      return (input && input.value) || this.dataset.variantId;
    }

    open() {
      this.lastFocus = document.activeElement;
      this.showStep('form');
      this.hideError();
      this.hidden = false;
      document.body.classList.add('pcp-bis-open');
      requestAnimationFrame(() => {
        this.classList.add('is-open');
        (this.emailInput.value ? this.submitBtn : this.emailInput).focus();
      });
      this.publish('pcp:back_in_stock_open');
    }

    close() {
      if (this.hidden) return;
      this.classList.remove('is-open');
      this.hidden = true;
      document.body.classList.remove('pcp-bis-open');
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    }

    trapFocus(e) {
      var focusables = Array.prototype.filter.call(
        this.panel.querySelectorAll('button, [href], input, [tabindex]:not([tabindex="-1"])'),
        function (el) { return !el.disabled && el.offsetParent !== null; }
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    showStep(name) {
      this.querySelectorAll('[data-bis-step]').forEach(function (el) {
        el.hidden = el.dataset.bisStep !== name;
      });
    }

    showError(msg) {
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
      this.emailInput.setAttribute('aria-invalid', 'true');
    }

    hideError() {
      this.errorEl.hidden = true;
      this.emailInput.removeAttribute('aria-invalid');
    }

    setBusy(busy) {
      this.submitBtn.disabled = busy;
      this.submitBtn.classList.toggle('loading', busy);
    }

    klaviyo(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(this.dataset.companyId), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          accept: 'application/vnd.api+json',
          revision: KLAVIYO_REVISION,
        },
        body: JSON.stringify(body),
      });
    }

    async submit() {
      var email = (this.emailInput.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        this.showError('Please enter a valid email address.');
        this.emailInput.focus();
        return;
      }
      this.hideError();
      this.setBusy(true);

      var variantId = this.currentVariantId();
      try {
        var res = await this.klaviyo('back-in-stock-subscriptions', {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: { email: email } } },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } },
            },
          },
        });
        // 202 = queued. Klaviyo also rejects a duplicate sign-up for the same variant -
        // the shopper is already on the list, so treat that as success too.
        if (!res.ok && res.status !== 409) throw new Error('bis ' + res.status);

        if (this.newsInput && this.newsInput.checked && this.dataset.listId) {
          // Best effort - a failure here must not undo the back-in-stock sign-up.
          this.klaviyo('subscriptions', {
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Back in stock form',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } },
                  },
                },
              },
              relationships: { list: { data: { type: 'list', id: this.dataset.listId } } },
            },
          }).catch(function () {});
        }

        setText(this, '[data-bis-email]', email);
        this.showStep('done');
        var closeBtn = qs(this, '[data-bis-step="done"] [data-bis-close]');
        if (closeBtn) closeBtn.focus();
        this.publish('pcp:back_in_stock_signup', { variant_id: String(variantId), news_opt_in: !!(this.newsInput && this.newsInput.checked) });
      } catch (err) {
        this.showError("Sorry, something went wrong. Please try again, or email hello@pinkcityprints.com.");
      } finally {
        this.setBusy(false);
      }
    }

    publish(name, extra) {
      try {
        if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
          var payload = { product: this.dataset.productHandle, product_name: this.dataset.productTitle };
          if (extra) for (var k in extra) payload[k] = extra[k];
          Shopify.analytics.publish(name, payload);
        }
      } catch (e) {}
    }
  }

  if (!customElements.get('pcp-back-in-stock')) customElements.define('pcp-back-in-stock', PcpBackInStock);

  // Open buttons are re-rendered on variant change, so delegate.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bis-open]');
    if (!btn) return;
    e.preventDefault();
    var dialog = document.getElementById('PcpBisDialog-' + btn.dataset.bisOpen);
    if (dialog) dialog.open();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initVariantSync);
  else initVariantSync();
})();
